import SvgIcon from '@mui/material/SvgIcon'

function FlickrIcon(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M10.002,11.272c0,2.761-2.24,5.002-5,5.002C2.239,16.274,0,14.033,0,11.272c0-2.761,2.239-5,5.002-5C7.76,6.272,10.002,8.511,10.002,11.272z M17.545,6.272c-2.76,0-5,2.239-5,5c0,2.761,2.24,5.002,5,5.002c2.764,0,5.002-2.241,5.002-5.002C22.547,8.511,20.309,6.272,17.545,6.272z" />
      </g>
    </SvgIcon>
  )
}

export default FlickrIcon
